import React from 'react';

/**
 * CustomIcon component to replace React Icons with custom icon images
 * Place your custom icons in /public/icons/ folder
 * 
 * Usage:
 * <CustomIcon name="heart" filled={true} className="w-6 h-6" />
 * <CustomIcon name="comment" className="w-6 h-6" />
 */
const CustomIcon = ({ name, filled = false, className = "w-6 h-6", alt = "", ...props }) => {
  // Construct the icon path
  // If filled is true, look for name-filled.png, otherwise name.png
  const iconName = filled ? `${name}-filled` : name;
  const iconPath = `/icons/${iconName}.png`;
  
  // Fallback to SVG if PNG doesn't exist
  const svgPath = `/icons/${iconName}.svg`;
  
  return (
    <img
      src={iconPath}
      alt={alt || `${name} icon`}
      className={className}
      onError={(e) => {
        // Fallback to SVG if PNG fails
        if (e.target.src !== svgPath) {
          e.target.src = svgPath;
        }
      }}
      {...props}
    />
  );
};

export default CustomIcon;
